export default __webpack_public_path__ + "static/media/ash.89422c54.png";